<div class="flex flex-col gap-3 md:gap-4" [formGroup]="formGroup">
    <h2 class="text-base text-shui-text-strong font-semibold m-0 my-2 p-0">
        {{ 'iro.order-details.title' | translate }}
    </h2>
    <div class="bg-shui-base-2 rounded-md p-4 my-2">
        <p class="text-base text-shui-text-moderate font-semibold m-0 mb-2 p-0">
            {{ 'iro.order-details.distributor-question' | translate }}
        </p>
        <sh-switch variant="squared" stretch>
            <sh-switch-item
                [label]="'common.general.yes' | translate"
                [active]="formGroup.controls.isDistributor.value === true"
                (click)="onDistributorAccountChange(true)"
            ></sh-switch-item>
            <sh-switch-item
                [label]="'common.general.no' | translate"
                [active]="formGroup.controls.isDistributor.value === false"
                (click)="onDistributorAccountChange(false)"
            ></sh-switch-item>
        </sh-switch>
        @if (formGroup.controls.isDistributor.value === true) {
            <div class="mt-4">
                <sh-select
                    formControlName="distributorName"
                    [label]="'iro.order-details.select-distributor' | translate"
                    [mandatory]="true"
                    [options]="distributorOptions"
                ></sh-select>
            </div>
        }
    </div>
    <div class="bg-shui-base-2 rounded-md p-4 my-2">
        <p class="text-base text-shui-text-moderate font-semibold m-0 mb-2 p-0">
            {{ 'iro.order-details.cpr-question' | translate }}
        </p>
        <sh-switch variant="squared" stretch>
            <sh-switch-item
                [label]="'common.general.yes' | translate"
                [active]="formGroup.controls.isCprContract.value === true"
                (click)="onCprContractChange(true)"
            ></sh-switch-item>
            <sh-switch-item
                [label]="'common.general.no' | translate"
                [active]="formGroup.controls.isCprContract.value === false"
                (click)="onCprContractChange(false)"
            ></sh-switch-item>
        </sh-switch>
        @if (formGroup.controls.isCprContract.value === true) {
            <span class="text-shui-tint-warning-250 text-xs font-semibold mt-2">{{
                'iro.order-details.cpr-pricing-removed' | translate
            }}</span>
        } @else {
            <span class="text-shui-text-subtle text-xs font-semibold mt-2">{{
                'iro.order-details.standard-pricing' | translate
            }}</span>
        }
    </div>
    <div class="bg-shui-base-2 rounded-md p-4 my-2">
        <p class="text-base text-shui-text-moderate font-semibold m-0 mb-2 p-0">
            {{ 'iro.order-details.months-of-inventory' | translate }}
        </p>
        <sh-input-text
            formControlName="monthsOfInventory"
            [label]="'iro.order-details.months-of-inventory-label' | translate"
            min="1"
            max="12"
            type="number"
            mandatory
        ></sh-input-text>
    </div>
    <div class="bg-shui-base-2 rounded-md p-4 my-2">
        <p class="text-base text-shui-text-moderate font-semibold m-0 mb-2 p-0">
            {{ 'iro.order-details.notification-emails-title' | translate }}
        </p>
        <sh-additional-emails
            formControlName="additionalEmails"
            [label]="'iro.order-details.notification-emails-label' | translate"
            [addButtonLabel]="'iro.order-details.notification-emails-add' | translate"
        ></sh-additional-emails>
        <span class="text-shui-text-subtle text-xs font-semibold mt-2">{{
            'iro.order-details.notification-emails-hint' | translate
        }}</span>
    </div>
    @if (showContinue()) {
        <div class="mt-2 flex items-center justify-end">
            <sh-button
                [label]="'common.general.continue' | translate"
                [disabled]="formGroup.invalid"
                (click)="onContinue()"
            ></sh-button>
        </div>
    }
</div>
